import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { COMMON_CONSTANTS } from '../../constants/constant';

interface ItemPerPage {
  id: number;
  value: string;
}

@Component({
  selector: 'app-ngx-common-footer',
  templateUrl: './ngx-common-footer.component.html',
  styleUrl: './ngx-common-footer.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class NgxCommonFooterComponent {

  @Input() page!: number;
  @Input() count!: number;

  @Output() currentPageLimits = new EventEmitter<string>();

  selectedValue: ItemPerPage = COMMON_CONSTANTS.PAGE_OPTIONS_LIST[1];
  pageLimitOptions: ItemPerPage[] = COMMON_CONSTANTS.PAGE_OPTIONS_LIST_LG;

  STRINGIFY_DROPDOWN_DISPLAY_ITEM = (item: ItemPerPage) => `${item.value}`;

  private _size = 0;
  private _selectedPageLimit: ItemPerPage = COMMON_CONSTANTS.PAGE_OPTIONS_LIST[1];

  @Input()
  set size(value: number) {
    if (value) {
      this._size = value;
      const selectedOption = this.pageLimitOptions.find(
          x => x.id === value || Number(x.value) === value
      );
      if (selectedOption) {
        this.selectedValue = selectedOption;
        this._selectedPageLimit = selectedOption;
      }
    }
  }
  get size(): number {
    return this._size;
  }

  // start row of current page (1-based)
  get startRow(): number {
    if (!this.count) { return 0; }
    return (this.page - 1) * this._size + 1;
  }

  // end row of current page, capped at total count
  get endRow(): number {
    return Math.min(this.page * this._size, this.count);
  }

  @Input()
  set selectedPageLimit(value: ItemPerPage) {
    this._selectedPageLimit = value ?? COMMON_CONSTANTS.PAGE_OPTIONS_LIST[1];
    this.selectedValue = this._selectedPageLimit;
  }
  get selectedPageLimit(): ItemPerPage {
    return this._selectedPageLimit;
  }

  onLimitChange(event: ItemPerPage): void {
    if (event) {
      this.selectedValue = event;
      this._selectedPageLimit = event;
      this.currentPageLimits.emit(event.id.toString());
    }
  }
}
